// Runtime guards for the shape of an already-parsed JSON response body.
// A `res.json() as T` cast is a compile-time assertion with zero runtime
// effect — if the brain and the agent box drift out of sync across an
// independent deploy (or any other 2xx-with-wrong-shape response), the cast
// happily produces `undefined`/non-array values that flow straight into
// reactive state and crash deep inside a component instead of surfacing
// through the store's existing error path (#1251).
//
// Usage: wrap the specific field being assigned into a ref, not the whole
// parsed body — that keeps the thrown message specific to what's actually
// missing/malformed, and lets fields with their own fallback (e.g. an
// optional `latest_per_repo ?? []`) apply that fallback before validating.
//
//   repos.value = expectArray<AgentRepoStatus>(data.repos, 'agent repos')

export function expectArray<T>(value: unknown, context: string): T[] {
  if (!Array.isArray(value)) throw new Error(`Unexpected response from ${context}`)
  return value as T[]
}

export function expectObject<T extends object>(value: unknown, context: string): T {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) {
    throw new Error(`Unexpected response from ${context}`)
  }
  return value as T
}
